(() => {
  const manualCountryKey = 'pw-localization-manual-country';
  const manualCountryCookie = 'pw_localization_manual_country';
  const domainCountries = {
    'www.pipandwells.com': 'IE', 'pipandwells.com': 'IE',
    'www.pipandwells.nl': 'NL', 'pipandwells.nl': 'NL',
    'www.pipandwells.de': 'DE', 'pipandwells.de': 'DE',
    'www.pipandwells.fr': 'FR', 'pipandwells.fr': 'FR',
    'www.pipandwells.at': 'AT', 'pipandwells.at': 'AT',
    'www.pipandwells.co.uk': 'GB', 'pipandwells.co.uk': 'GB'
  };

  function readCookie(name) {
    if (!document.cookie) return '';
    const prefix = `${name}=`;
    return document.cookie.split('; ').find((item) => item.startsWith(prefix))?.slice(prefix.length) || '';
  }

  function hasManualCountryChoice() {
    try {
      return Boolean(window.localStorage.getItem(manualCountryKey) || readCookie(manualCountryCookie));
    } catch (_) {
      return Boolean(readCookie(manualCountryCookie));
    }
  }

  function rememberManualCountryChoice(countryCode) {
    if (!countryCode) return;
    try {
      window.localStorage.setItem(manualCountryKey, countryCode);
    } catch (_) {
      // The first-party cookie below remains the durable manual-choice marker.
    }
    document.cookie = `${manualCountryCookie}=${encodeURIComponent(countryCode)}; path=/; max-age=31536000; SameSite=Lax`;
  }

  function resolveTargetCountry(_context, availableCountries) {
    const swissPath = ['www.pipandwells.com', 'pipandwells.com'].includes(location.hostname) && /^\/(de|fr)-ch(?:\/|$)/.test(location.pathname);
    const target = swissPath ? 'CH' : domainCountries[location.hostname];
    return target && availableCountries.includes(target) ? target : '';
  }

  window.PWLocalizationContext = { resolveTargetCountry };

  function submitCountry(targetCountry) {
    const form = document.createElement('form');
    form.action = `${window.Shopify?.routes?.root || '/'}localization`;
    form.method = 'post';
    form.hidden = true;
    form.dataset.pwAutoLocalization = 'true';
    form.innerHTML = `<input name="_method" value="put"><input name="country_code" value="${targetCountry}"><input name="return_to" value="${location.pathname}${location.search}${location.hash}">`;
    document.body.append(form);
    form.submit();
  }

  function registerManualChoiceListener() {
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || form.dataset.pwAutoLocalization === 'true') return;
      const submitter = event.submitter;
      const countryCode = submitter?.getAttribute('name') === 'country_code' ? submitter.value : new FormData(form).get('country_code');
      if (countryCode) rememberManualCountryChoice(countryCode);
    }, true);
  }

  function restoreCountryContext(script) {
    if (hasManualCountryChoice()) return;

    const currentCountry = script.dataset.currentCountry;
    const availableCountries = script.dataset.availableCountries.split(',').filter(Boolean);
    if (!currentCountry) return;

    const targetCountry = resolveTargetCountry(null, availableCountries);
    if (!targetCountry) return;
    if (targetCountry !== currentCountry) submitCountry(targetCountry);
  }

  if (!document.addEventListener) return;
  document.addEventListener('DOMContentLoaded', () => {
    registerManualChoiceListener();
    const script = document.currentScript || document.querySelector('[data-pw-localization-context]');
    if (script) restoreCountryContext(script);
  }, { once: true });
})();
